import AdjustmentListTab from './AdjustmentListTab';

export default AdjustmentListTab;
